/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { ApplyIdActionsNames } from './apply-id-action-name';

export const ChangeHeight = createAction(
  ApplyIdActionsNames.ChangeHeight(),
  props<{ height: number}>()
);

export const ChangeHeightSuccess = createAction(
  ApplyIdActionsNames.ChangeHeightSuccess(),
  props<{ response: string }>()
);

export const ValidateSelection = createAction(ApplyIdActionsNames.ValidateSelection());

export const ValidateSelectionSuccess = createAction(
  ApplyIdActionsNames.ValidateSelectionSuccess(),
  props<{ response: any }>()
);

export const ApplyIdClick = createAction(ApplyIdActionsNames.ApplyIdClick(), props<{ id: string }>());

export const ApplyIdClickSuccess = createAction(
  ApplyIdActionsNames.ApplyIdClickSuccess(),
  props<{ response: string }>()
);

export const ClosePopupAction = createAction(ApplyIdActionsNames.ClosePopupAction());

export const ClosePopupActionSuccess = createAction(
  ApplyIdActionsNames.ClosePopupActionSuccess(),
  props<{ response: string }>()
);
